"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@stt-componentes/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Grid = function Grid(props) {
  var strings = props.strings,
    decs = props.decs,
    handleDelete = props.handleDelete;
  return /*#__PURE__*/_react["default"].createElement(_core.SttTable, null, /*#__PURE__*/_react["default"].createElement(_core.SttTableHead, null, /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, null, /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
    smDown: true
  }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
    width: "10%"
  }, strings.sigla), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
    width: "40%"
  }, strings.descritor), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
    width: "40%"
  }, strings.descritorAntecessor), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
    width: "10%"
  }, strings.excluir)), /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
    mdUp: true
  }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
    width: "100%",
    colSpan: "2"
  }, strings.decs)))), /*#__PURE__*/_react["default"].createElement(_core.SttTableBody, null, decs.length === 0 ? /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
    key: -1
  }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
    colSpan: 4,
    align: "center"
  }, strings.nenhumDecsAdicionado)) : decs.map(function (row, index) {
    return /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
      smDown: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.id), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.descritor), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.descritor_antecessor)), /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
      mdUp: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "96%"
    }, /*#__PURE__*/_react["default"].createElement(_core.SttText, {
      size: "small"
    }, /*#__PURE__*/_react["default"].createElement("b", null, strings.sigla, ":"), " ", row.id), /*#__PURE__*/_react["default"].createElement(_core.SttText, {
      size: "small"
    }, /*#__PURE__*/_react["default"].createElement("b", null, strings.descritor, ":"), " ", row.descritor), /*#__PURE__*/_react["default"].createElement(_core.SttText, {
      size: "small"
    }, /*#__PURE__*/_react["default"].createElement("b", null, strings.descritorAntecessor, ":"), " ", row.descritor_antecessor))), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      align: "center"
    }, /*#__PURE__*/_react["default"].createElement(_core.SttDeleteButton, {
      id: "btn-excluir-decs-".concat(index),
      onClick: function onClick() {
        return handleDelete(index);
      }
    })));
  })));
};
Grid.propTypes = {
  strings: _propTypes["default"].object.isRequired,
  decs: _propTypes["default"].array.isRequired,
  handleDelete: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = Grid;